import e from "../../utils/classNames.js";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/selects/WithFeedbackAndAddon.tsx
var i = (i) => {
	let { bsSize: a = "md", inputAddon: o, errorMessage: s, warningMessage: c, messageWhiteSpace: l = "normal", children: u } = i, d = e("form-group margin-bottom-0", !!(s || c) && "has-feedback", !!s && "has-error", !!c && "has-warning"), f = e("input-group", a === "sm" && "input-group-sm", a === "lg" && "input-group-lg");
	return /* @__PURE__ */ n("div", {
		className: d,
		children: /* @__PURE__ */ r("div", {
			className: f,
			children: [o && /* @__PURE__ */ n("div", {
				className: "input-group-addon",
				children: /* @__PURE__ */ n("span", { className: o })
			}), /* @__PURE__ */ r("div", {
				className: "form-control-feedback-wrapper",
				children: [u, (s || c) && /* @__PURE__ */ r(t, { children: [
					s && /* @__PURE__ */ n("span", { className: "form-control-feedback uikit-icon icon-error-sign" }),
					c && /* @__PURE__ */ n("span", { className: "form-control-feedback uikit-icon icon-warning-sign" }),
					/* @__PURE__ */ n("span", {
						className: `help-block white-space-${l}`,
						children: /* @__PURE__ */ n("span", { children: s || c })
					})
				] })]
			})]
		})
	});
};
//#endregion
export { i as default };

//# sourceMappingURL=WithFeedbackAndAddon.js.map